/** Class on <html> while the admin edits copy (index.css ghosts hidden blocks). */
export const COPY_EDIT_CLASS = "nx-copy-edit";
